import { observable, action } from 'mobx';
import agent from '../agent';
import commonStore from './commonStore';

class UserStore {
  @observable self;
  @observable loadingSelf;
  @observable updatingUser;
  @observable updatingUserErrors;
  @observable currentUser;

  constructor() {
    if (commonStore.token) {
      this.updateSelf().catch(err => {
        console.error(err);
        console.log('AN INVALID TOKEN HAS BEEN SENT, TAKING EVASIVE ACTIONS.');
        // TODO show modal saying the token is wrong.
      });
    }
  }

  @action
  updateSelf() {
    this.loadingSelf = true;
    return agent.Auth.current()
      .then(
        action(userResponse => {
          this.self = userResponse.status && userResponse.content;
        })
      )
      .finally(
        action(() => {
          this.loadingSelf = false;
        })
      );
  }

  @action
  forgetUser() {
    this.self = undefined;
  }
}

export default new UserStore();



// WEBPACK FOOTER //
// ./src/store/userStore.js